import { connect, useSelector } from "react-redux";
import { createMembershipPlan } from "../../commercial_membership/store/action";
import {
  CreateMembershipPlanInput,
  CreateMembershipPlanInputError,
  MembershipPlansProps,
  stateStatusType,
} from "../../commercial_membership/store/actionType";
import { CommercialUserProps } from "modules/user_management/commercial_user/user/state/actionType";
import MembershipPlanForm from "../../commercial_membership/pages/manage_membership_plan/components/MembershipPlanForm";
import { ChangeEvent, FormEvent, useEffect, useState } from "react";
import { ApiError } from "components";

interface OwnProps {
  userData?: CommercialUserProps;
  user_id?: string 
}
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type StateProps = ReturnType<typeof mapStateToProps>;
type Props = DispatchProps & OwnProps & StateProps;
const HandleCreateMembershipPlan: React.FC<Props> = ({
  userData,
  onCreateMembershipPlan,
  user_id
}) => {
  const membershipPlanState = useSelector(
    (state: any) => state.membershipPlan?.genericMembershipPlanState
  );
  const membershipData: MembershipPlansProps = membershipPlanState?.updatedData;
  const [loading, setLoading] = useState(false);
  const [membershipCreated, seMembershipCreated] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [apiError, setApiError] = useState<string | null>(null);
  const [formData, setFormData] = useState<CreateMembershipPlanInput>({
    membership_duration_id: "",
    user_id: userData?.id.toString(),
  });
  const [error, setError] = useState<CreateMembershipPlanInputError>({});

  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => {
    const { name, value, type } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "number" ? Number(value) : value,
    }));
    setError((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const handleSave = async (e: FormEvent) => {
    e.preventDefault();

    if (!formData.package_id || !formData.membership_duration_id) {
      setError({
        membership_duration_id: formData.membership_duration_id
          ? ""
          : "Duration is required",
      });
      return;
    }

    setSubmitted(true);
    setLoading(true);

    try {
      const input: CreateMembershipPlanInput = {
        membership_duration_id: formData.membership_duration_id,
        user_id: userData?.id ? userData?.id : user_id,
      };
      await onCreateMembershipPlan(input);
    } catch (err) {
      console.error("Failed to create membership plan:", err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (!membershipPlanState?.isLoading && submitted) {
      if (membershipPlanState?.status === stateStatusType.SUCCESS) {
        seMembershipCreated(true);
        setApiError(null);
        setSubmitted(false);
      }
      if (membershipPlanState?.status === stateStatusType.FAILED) {
        setApiError(membershipPlanState.error);
        seMembershipCreated(false);
      }
    }
  }, [membershipPlanState, submitted, seMembershipCreated]);
  return (
    <>
      {membershipCreated ? (
        <>
          <div className="max-w-md mx-auto p-6 mt-10 bg-white rounded-2xl shadow-md border">
            <div className="flex items-center space-x-3 mb-4">
              <div className="flex items-center justify-center w-10 h-10 rounded-full bg-primary-400 text-white">
                ✓
              </div>
              <h2 className="text-lg font-semibold text-gray-800">
                Membership Created Successfully
              </h2>
            </div>

            <ul className="space-y-2 text-sm text-gray-700">
              <li className="flex justify-between">
                <span className="font-medium text-gray-600">
                  Membership Plan:
                </span>
                <span>{membershipData?.membership_details?.package?.name ?? "-"}</span>
              </li>
              <li className="flex justify-between">
                <span className="font-medium text-gray-600">Start Date:</span>
                <span>{membershipData?.membership_join_date ?? "-"}</span>
              </li>
              <li className="flex justify-between">
                <span className="font-medium text-gray-600">End Date:</span>
                <span>{membershipData?.membership_end_date ?? "-"}</span>
              </li>
              <li className="flex justify-between">
                <span className="font-medium text-gray-600">User ID:</span>
                <span>{membershipData?.user_id ?? "-"}</span>
              </li>
            </ul>
          </div>
        </>
      ) : (
        <MembershipPlanForm
          handleSave={handleSave}
          formData={formData}
          handleChange={handleChange}
          error={error}
          loading={loading}
          header="Create Membership Plan"
          isSerachUser
        />
      )}
      {apiError && <ApiError>{apiError}</ApiError>}
    </>
  );
};
const mapStateToProps = (state: any) => ({
  fetchCommercialUsersState: state.commercialUser.commercialUserState,
});

const mapDispatchToProps = (dispatch: any) => ({
  onCreateMembershipPlan: (input: CreateMembershipPlanInput) =>
    dispatch(createMembershipPlan(input)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HandleCreateMembershipPlan);
